var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.isLoading)?_c('p-logistic-offer-list',{attrs:{"logisticOffers":_vm.logisticOfferList},on:{"delete-offer":_vm.deleteOfferFromList}}):_c('p-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }